import { render, staticRenderFns } from "./Vaccines.vue?vue&type=template&id=0a19e8cc&"
import script from "./Vaccines.vue?vue&type=script&lang=js&"
export * from "./Vaccines.vue?vue&type=script&lang=js&"
import style0 from "./Vaccines.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports